import { render } from "./NameAndMobileNumberForm.html?vue&type=template&id=7b1e1604&scoped=true&external"
import script from "./NameAndMobileNumberForm.js?vue&type=script&lang=js&external"
export * from "./NameAndMobileNumberForm.js?vue&type=script&lang=js&external"

import "./NameAndMobileNumberForm.css?vue&type=style&index=0&id=7b1e1604&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1e1604"]])

export default __exports__